import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { NGXLogger } from "ngx-logger";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { SignInState } from "../components/allusers/signin/signin.model";
import {
  getSignedInUser,
  isSignedOut
} from "../components/allusers/signin/signin.selector";
import { AuthService } from "../services/auth-service/auth.service";
import { User } from "src/app/models/user.model";



@Injectable()
export class MemberGuard implements CanActivate {
  getLoggedInUser$ = this.loginStore.pipe(
    select(getSignedInUser),
    filter(val => (val ? true : false))
  );
  loggedInUser: any;
  isLoggedOut$ = this.loginStore.pipe(
    select(isSignedOut),
    filter(val => (val ? true : false))
  );
  
  currentUser$ = this.loginStore.pipe(select(getSignedInUser));
  currentUser: User;
  routeParamsSubscription$: Subscription;

  constructor(
    private router: Router,
    private authService: AuthService,
    private loginStore: Store<SignInState>,        
    private logger: NGXLogger
  ) {
    this.getLoggedInUser$.subscribe(user => (this.loggedInUser = user));
    this.isLoggedOut$.subscribe(() => (this.loggedInUser = null));    
    this.currentUser$.subscribe(user => this.currentUser = user);
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {    
    // User not in store, try to fetch it (handles page refresh)
    try {
      this.loggedInUser = await this.authService.getLoggedInUser();
      if (this.loggedInUser) {
        // Retry the check with the fetched user
        if (this.loggedInUser.memberstatus === "paid") {        
          return true;
        } else if (this.loggedInUser.memberstatus === "admin") {        
          return true;
        } else if (
          this.loggedInUser.memberstatus ||
          this.loggedInUser.memberstatus === "" ||
          this.loggedInUser.memberstatus === "not_paid"
        ) {
          return true;
        } 
      }
    } catch (err) {
      this.logger.info('User not logged in - ', err);
    }  
    
    // User not logged in, redirect to home
    this.router.navigate(["/home"], {
      queryParams: route.queryParams
    });
    return false;
  }  
}